module.exports = __webpack_public_path__ + "static/img/19.89260df5.gif";